import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { EndpointFactory } from './endpoint-factory.service';
import { ConfigurationService } from './configuration.service';


@Injectable({ providedIn: 'root'})
export class KappaEndpoint extends EndpointFactory {

  private readonly _kappaTypesUrl: string = '/api/report/kappatypes';

  get kappaTypesUrl() { return this.configurations.baseUrl + this._kappaTypesUrl; }

  constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
    super(http, configurations, injector);
  }

  getKappaTypesEndpoint<T>(): Observable<T> {
    return this.http.get<T>(this.kappaTypesUrl, this.getRequestHeaders());
  }
}
